import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'nprogress/nprogress.css';
import VueCookies from 'vue-cookies';
import {auth} from './services/FirebaseService';

import 'aframe';

Vue.config.productionTip = false;

Vue.config.ignoredElements = ['a-scene', 'a-node', 'a-assets', 'a-videosphere'];

Vue.use(VueCookies);

async function initAuth(user) {
  store.state.user = user;
  store.state.accountName = user?.displayName;
}

async function init() {
  await auth.authStateReady();
  await initAuth(auth.currentUser);
  auth.onAuthStateChanged(async user => {
    if (store.state.user != user) {
      console.log(`user sate changed ${user}`);
      await initAuth(user);
      if (!user) {
        router.push('/login');
      }
    }
  });

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount('#app');
}

init();
